'use client';

import { SerialCodeInput as CommonSerialCodeInput, type SerialCodeInputProps } from '@monorepo/common';
import SerialCodeFormText from '../SerialCodeFormText/SerialCodeFormText';

function SerialCodeInput({
  SerialCodeFormTextComponent,
  ...props
}: Omit<SerialCodeInputProps, 'SerialCodeFormTextComponent'> & {
  SerialCodeFormTextComponent?: SerialCodeInputProps['SerialCodeFormTextComponent'];
}) {
  return (
    <CommonSerialCodeInput SerialCodeFormTextComponent={SerialCodeFormTextComponent || SerialCodeFormText} {...props} />
  );
}

export default SerialCodeInput;
